import { PipeTransform, Pipe } from '@angular/core';
import { escapeHtml } from '../utils/string.utils';

@Pipe({
    name: 'searchHighlight',
    standalone: false
})
export class SearchHighlightPipe implements PipeTransform {
    private readonly HIGHLIGHT_CLASS = 'hc-text-highlight';
    public transform(text: string, search = '', trimLength?: number): string {
        if (!text || text.length === 0 || (!search && !trimLength)) {
            return escapeHtml(text);
        }
        let trimStart = 0,
            regex: RegExp | null = null,
            escapedSearch = search,
            matchLengthExceedsTrimLength = false;

        if (search) {
            // set up regex if running a search
            // eslint-disable-next-line no-useless-escape
            escapedSearch = escapeHtml(search);
            let pattern = escapedSearch.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
            pattern = pattern
                .split(' ')
                .filter(t => t.length > 0)
                .join('|');
            regex = new RegExp(pattern, 'gi');

            // if also need to trim, lets make sure we trim such that any search match will be visible
            if (trimLength) {
                const matches = regex.exec(text) || [];
                const firstMatch = <string>matches[0] || '';
                const matchStart = text.indexOf(firstMatch);
                const matchEnd = matchStart + firstMatch.length;
                const proposedStart = matchEnd - trimLength > 0 ? matchEnd - trimLength : 0;
                matchLengthExceedsTrimLength = firstMatch.length > trimLength;
                trimStart = matchLengthExceedsTrimLength ? matchStart : proposedStart;
            }
        }

        // actually do the trimming, with appended/prepended elipses as needed
        if (trimLength && text.length > trimLength) {
            const trimmed = text.slice(trimStart, trimStart + trimLength);
            text = `${trimStart > 0 ? '...' : ''}${trimmed}...`;
        }

        // add the highlighting wrapper as needed, and return the text escaped regardless
        const escapedText = escapedSearch == search ? text : escapeHtml(text);
        if (matchLengthExceedsTrimLength) {
            return `<span class="${this.HIGHLIGHT_CLASS}">${escapedText}</span>`;
        } else {
            return regex
                ? escapedText.replace(regex, match => `<span class="${this.HIGHLIGHT_CLASS}">${match}</span>`)
                : escapedText;
        }
    }
}
